import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as AdminIndexActions from '../../actions/admin/Index/adminIndexAction';
import Pagination from "react-js-pagination";
import Moment from 'react-moment';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import autoBind from 'auto-bind';

let btnSize = { fontSize: '13' };
class PageList extends React.Component {
	constructor(props, context) {
		super(props, context);
		autoBind(this);
		this.state = {
			isLoader: true,
			logList: [],
			token: '',
			flag: 1,
			activePage: 1,
			count: 10,
			sortColumnName: '',
			sortOrder: -1,
			totalCount: 0,
			//name:'',
			//role:'',
			//role_id,
		}
		// this.deleteemailTemplate = this.deleteemailTemplate.bind(this);
	}

	componentWillMount() {
		//let l = localStorage.getItem('user');
		//console.log("############",l.fisrtname);
		// console.log(localStorage.getItem('user'),"local")
		const user = JSON.parse(localStorage.getItem('user'));
		const role = localStorage.getItem('roles');
		console.log(user);
		console.log("22222222222222222222222222222222",role);
		//var startDate = new Date().getDate();
		var result1 = new Date();
		
		//console.log("startDate",result1);
		
		//var endDate= startDate.setDate(startDate + 30);
		//console.log("endDateendDateendDateendDateendDate",endDate);
		var result = new Date();
		result.setDate(result.getDate() + 30);
		//console.log("endDateendDateendDateendDateendDate",result);
		let object = {
			page: this.state.activePage,
			count: this.state.count,
			name: user ? user.userName : '',
			role_id: user && user.role_id ? user.role_id._id : '',
			role:role,
			startDate :result1,
			endDate:result ,
		}
		console.log("@@@@@@@@@@@@@@@",object);
		
		//this.props.actions.getLogsList(object, this.props);
		this.props.actions.getLogsList(object);
		
	}

	handlePageChange(pageNumber) {
		this.setState({ activePage: pageNumber });
		let object = {
			page: pageNumber,
			count: this.state.count,
			
		}
		this.props.actions.getLogsList(object);
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.success) {
			this.setState({
				logList: nextProps.logList,
				totalCount: nextProps.totalCount,
				// totalCount: nextProps.logList.length,
			})
		} else {
			this.setState({
				isLoader: false
			})
		}
	}

	render() {
		var rows = [];
		this.state.logList.forEach(function (item, index) {
			rows.push(
				<tr key={index}>
					<td>{index + 1}</td>
					<td>{item.userInfo.username}</td>
					<td>{item.fieldName}</td>
					<td> {item.previousData}</td>
					<td> {item.latestData}</td>
					<td> <Moment format="DD-MMM-YYYY">{item.createdAt}</Moment></td>
				</tr >
			)
		}.bind(this));
		return (
			<div className="content-wrapper" >

				<section className="content container-fluid">
					<ToastContainer />
					<div className="row">
						<div className="col-md-12">
							<div className="boxMrgB proCalendar">
								<div className="nav-tabs-custom">
									<ul className="nav nav-tabs">
										<li ><Link to="#tab_1" data-toggle="tab" className="active show">Audit Logs</Link></li>

									</ul>
									<div className="uploadImg-btn">
									</div>
									<div className="row">
										<div className="col-md-12">
											<div className="tab-content tabother ">
												<div className="row">
													<div className="box-body table-responsive no-padding aTable">
														<table className="table">
															<tbody>
																<tr>
																	<th >
																		Sr. No.
                               										 </th>
																	<th>User</th>
																	<th>Field Name</th>
																	<th>Previous Data</th>
																	<th>Latest Data</th>
																	<th >Created</th>
																</tr>
																{rows && rows.length > 0 ? rows : <tr><td colSpan={4} className="text-center">There are no Logs created</td></tr>}
															</tbody>
														</table>
													</div>
												</div>
												{(this.state.totalCount && this.state.totalCount >= 10) ?
													<div className="row">
														<div className="col-sm-5">Showing {(this.state.activePage * this.state.count) - (this.state.count - 1)} to {(this.state.activePage * this.state.count) > this.state.totalCount ? this.state.totalCount : (this.state.activePage * this.state.count)} of {this.state.totalCount} entries</div>
														<div className="col-sm-7 text-right" style={{ "cursor": "pointer" }}>
															<Pagination
																prevPageText='Prev'
																nextPageText='Next'
																hideFirstLastPages
																activePage={this.state.activePage}
																itemsCountPerPage={10}
																totalItemsCount={this.state.totalCount}
																pageRangeDisplayed={10}
																onChange={this.handlePageChange.bind(this)}
															/>
														</div>
													</div>
													  : ''} 
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</section>
				<div className="Copyrightafterlogin">
					<p>Medfix &copy; 2018. All rights reserved</p>

				</div>
			</div>
		);
	}
}

//this tells what state should expose on props
function mapStateToProps(state, ownProps) {
	console.log('1111111111111111', localStorage);
	return {
		logList: state.adminUser.logs ? state.adminUser.logs.data : [],
		totalCount: state.adminUser.logs ? state.adminUser.logs.totalCount : 0,
		success: state.adminUser.logs ? state.adminUser.logs.success : false
	};
}
//bindActionCreators is used to bind all actions at once
function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators(AdminIndexActions, dispatch),
	};
}
export default connect(mapStateToProps, mapDispatchToProps)(PageList);